export default __webpack_public_path__ + "static/media/learn-JavaScript.6b00a759.jpg";